import React from "react";
import Documentation from "../Components/Documentation";

const MainDocumentation = () => <Documentation />;

export default MainDocumentation;
